<div class="ui-g-12">

    <div class="ui-g">
        <div *ngFor="let indicator of indicators" class="ui-g-12 ui-md-3 ui-sm-6">
            <app-infobox [pointData]="indicator.pointData" [penetration]="indicator.penetration" [options]="indicator.options"></app-infobox>
        </div>
    </div>

    <div class="ui-g-12 ui-md-6 ui-sm-12"  *ngIf="data != null">
        <h2>{{ this.translations.investimento_fatturato_promo }}</h2>
        <div class="chart-container">
            <chart [options]="revenueInvestmentColumn.options"
                   (load)="setChartInstance(revenueInvestmentColumn, $event.context)"></chart>
        </div>
    </div>


    <div class="ui-g-12 ui-md-6 ui-sm-12" *ngIf="data != null">
          <h2>{{ this.translations.fatturato_target_group_control_group }}</h2>
          <div class="chart-container">
            <chart [options]="revenueTargetLine.options"
                   (load)="setChartInstance(revenueTargetLine, $event.context)"></chart>
          </div>
    </div>

  <div class="ui-g-12 ui-md-12 ui-sm-12" *ngIf="data != null">
    <p-table [value]="datatablePromo" class="overview-table">

      <ng-template pTemplate="header">
        <tr>
          <th [pSortableColumn]="'obiettivo_iniziativa'">
              <span class="sortableCol">{{ translations.obiettivo_iniziativa }}</span>
              <p-sortIcon class="sortableIcon" [field]="'obiettivo_iniziativa'"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'numero_campagne_totali'">
              <span class="sortableCol">{{ translations.numero_campagne_totali }}</span>
              <p-sortIcon class="sortableIcon" [field]="'numero_campagne_totali'"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'investimento_totale'">
              <span class="sortableCol">{{ translations.investimento_totale }}</span>
              <p-sortIcon class="sortableIcon" [field]="'investimento_totale'"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'sconto_medio'">
              <span class="sortableCol">{{ translations.sconto_medio }}</span>
              <p-sortIcon class="sortableIcon" [field]="'sconto_medio'"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'redemption'">
              <span class="sortableCol">{{ translations.redemption }}</span>
              <p-sortIcon class="sortableIcon" [field]="'redemption'"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'spesa_incrementale'">
              <span class="sortableCol">{{ translations.spesa_incrementale }}</span>
              <p-sortIcon class="sortableIcon" [field]="'spesa_incrementale'"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'spesa_incrementale_baseline'">
              <span class="sortableCol">{{ translations.spesa_incrementale_baseline }}</span>
              <p-sortIcon class="sortableIcon" [field]="'spesa_incrementale_baseline'"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'spesa_associata'">
              <span class="sortableCol">{{ translations.spesa_associata }}</span>
              <p-sortIcon class="sortableIcon" [field]="'spesa_associata'"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'roi'">
              <span class="sortableCol">{{ translations.roi }}</span>
              <p-sortIcon class="sortableIcon" [field]="'roi'"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-col>
        <tr>
          <td class="number-column">{{ col.obiettivo_iniziativa }}</td>
          <td class="number-column">{{ col.numero_campagne_totali }}</td>
          <td class="number-column">{{ col.investimento_totale | number : '1.2-2'}} M€</td>
          <td class="number-column">{{ col.sconto_medio | formatNumber:2}} %</td>
          <td class="number-column">{{ col.redemption | formatNumber:2}} %</td>
          <td class="number-column">{{ col.spesa_incrementale | number : '1.2-2'}} M€</td>
          <td class="number-column">{{ col.spesa_incrementale_baseline | formatNumber:2 }} %</td>
          <td class="number-column">{{ col.spesa_associata | number : '1.2-2' }} M€</td>
          <td class="number-column">{{ col.roi }}</td>
        </tr>
      </ng-template>

    </p-table>

  </div>

    <p-dialog header="Error" [(visible)]="storeError" [width]="300" [modal]="true" [draggable]="false" [resizable]="false">
        <p>{{ selectOneError }}</p>
        <div class="ui-dialog-footer">
            <button pButton type="button" class="slim red-button" (click)="toogleErrorStoreDialog()" label="Ok"></button>
        </div>
    </p-dialog>

</div>



// WEBPACK FOOTER //
// ./src/app/views/analytics/promo/overview/overview-loyalty-1-1/overview-loyalty-1-1.component.html